<template>
  <b-modal v-model="show" size="lg" @close="onCancel">
    <template v-slot:modal-title>
      <div v-if="message == 'approve'" v-text="$t('messages.approve_title')"></div>
      <div v-if="message == 'reject'" v-text="$t('messages.reject_title')"></div>
      <div v-if="message == 'draft'" v-text="$t('messages.draft_title')"></div>
    </template>
    <div v-if="message == 'approve'" class="my-2" v-html="$t('messages.approve_reason_description')"></div>
    <div v-if="message == 'reject'" class="my-2" v-html="$t('messages.reject_reason_description')"></div>
    <div v-if="message == 'draft'" class="my-2" v-html="$t('messages.draft_reason_description')"></div>
    <div class="col-lg-12 pl-0 pr-3">
      <b-form-group
        id="fieldset-reason"
        label-for="reason"
        label-size="lg"
        label-class="font-weight-bold pb-0"
        class="required"
      >
        <b-form-input
          id="reason"
          name="reason"
          v-model.trim="reason"
          :placeholder="$t('messages.enter_reason')"
        />
      </b-form-group>
    </div>
    <template v-slot:modal-footer>
      <b-button type="submit" variant="primary" class="text-capitalize" :disabled="reason == ''" @click="onConfirm">OK</b-button>
      <b-button type="reset" variant="danger" @click="onCancel"
        >Cancel</b-button
      >
    </template>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      resolve: null,
      reject: null,
      message: "",
      reason: "",
    };
  },
  methods: {
    open(message) {
      this.message = message;
      this.show = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    onConfirm() {
      this.resolve(this.reason);
      this.show = false;
    },
    onCancel() {
      this.resolve(false);
      this.show = false;
    },
  },
};
</script>
